import React, { useState } from 'react';
import './../../entrydoor.css';

const DoorLiteCollection = ({ value, onChange, label = 'Door Lite Collection' }) => { // Set default value for childs
    const [selectedDoorLiteCollection, setSelectedDoorLiteCollection] = useState(value || "");

    const handleDoorLiteCollectionChange = (e) => {
        const newValue = e.target.value;
        setSelectedDoorLiteCollection(newValue);
        onChange(newValue);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteCollection">{label}</label>
            <select
                id="DoorLiteCollection"
                value={selectedDoorLiteCollection}
                onChange={handleDoorLiteCollectionChange}
            >
              <option value="" disabled hidden>Select Collection</option>  
              <option value='Decorative Glass'>{selectedDoorLiteCollection === 'Decorative Glass' ? 'Decorative Glass ✔' : 'Decorative Glass'}</option>
              <option value='Textured Glass'>{selectedDoorLiteCollection === 'Textured Glass' ? 'Textured Glass ✔' : 'Textured Glass'}</option>
              <option value='Wrought Iron'>{selectedDoorLiteCollection === 'Wrought Iron' ? 'Wrought Iron ✔' : 'Wrought Iron'}</option>
              <option value='Commodity Glass'>{selectedDoorLiteCollection === 'Commodity Glass' ? 'Commodity Glass ✔' : 'Commodity Glass'}</option>
              <option value='Internal Raise & Lower Blinds'>{selectedDoorLiteCollection === 'Internal Raise & Lower Blinds' ? 'Internal Raise & Lower Blinds ✔' : 'Internal Raise & Lower Blinds'}</option>
              <option value='Vents'>{selectedDoorLiteCollection === 'Vents' ? 'Vents ✔' : 'Vents'}</option>
              <option value='ODL - SDL Bars'>{selectedDoorLiteCollection === 'ODL - SDL Bars' ? 'ODL - SDL Bars ✔' : 'ODL - SDL Bars'}</option>
              <option value='Vertical Accent Contemporary PVC/Aluminum'>{selectedDoorLiteCollection === 'Vertical Accent Contemporary PVC/Aluminum' ? 'Vertical Accent Contemporary PVC/Aluminum ✔' : 'Vertical Accent Contemporary PVC/Aluminum'}</option>
              <option value='Custom Glass/Cutout Options'>{selectedDoorLiteCollection === 'Custom Glass/Cutout Options' ? 'TriCustom Glass/Cutout Optionsmlite ✔' : 'Custom Glass/Cutout Options'}</option>

            </select>
        </div>
    );
};

export default DoorLiteCollection;
